// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://kiywhtvfuzceuamolkrw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtpeXdodHZmdXpjZXVhbW9sa3J3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM4MTY4MTcsImV4cCI6MjA2OTM5MjgxN30.9woCshwd7Ue9FP3CFYUvoOi95oeSKWjZLVpv3VuAj-4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});